// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1LtQZ","location":"Header_location__25NGY"};